import { render, staticRenderFns } from "./LdapSync.vue?vue&type=template&id=f6736b5a&scoped=true&"
import script from "./LdapSync.vue?vue&type=script&lang=js&"
export * from "./LdapSync.vue?vue&type=script&lang=js&"
import style0 from "./LdapSync.vue?vue&type=style&index=0&id=f6736b5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6736b5a",
  null
  
)

export default component.exports